import * as React from 'react';

// @ts-expect-error
import {PieChart, Pie, Tooltip, Cell} from 'recharts';

import type {Item} from 'shells/table/item-count-table';

import {DonutChartTooltip} from './donut-chart-tooltip';

type Props = {
    width: number;
    items: Item[];
    handlePieClick?: (bucket: string) => void;
    singularNoun: string;
    pluralNoun: string;
    customTooltip?: (payload?: any) => React.ReactElement;
};

export function DonutChart(props: Props) {
    const [hoveredIndex, setHoveredIndex] = React.useState<number | null | undefined>(null);

    const onMouseOver = (data: any, index: number) => {
        setHoveredIndex(index);
    };

    const onMouseLeave = () => {
        setHoveredIndex(null);
    };

    const ChartTooltip = props.customTooltip || DonutChartTooltip;

    return (
        <PieChart width={props.width} height={props.width}>
            <Pie
                data={props.items}
                dataKey='count'
                outerRadius={props.width / 2}
                innerRadius={props.width / 5}
                // @ts-expect-error
                onMouseOver={(data, index) => onMouseOver(data, index)}
                onMouseLeave={onMouseLeave}
                // @ts-expect-error
                onClick={(data) => {
                    if (props.handlePieClick) {
                        props.handlePieClick(data.bucket);
                    }
                }}
            >
                {props.items.map((entry, index) => (
                    <Cell
                        className='pointer-cursor'
                        key={entry.bucket}
                        style={index === hoveredIndex ? {opacity: '0.8'} : undefined}
                    />
                ))}
            </Pie>
            <Tooltip
                // @ts-expect-error
                content={(payload) => (
                    <ChartTooltip
                        payload={payload}
                        singlularNoun={props.singularNoun}
                        pluralNoun={props.pluralNoun}
                    />
                )}
            />
        </PieChart>
    );
}
